<div id="globalGlobalContainer">
    <div id="GreekParallax"> </div>
<div id="globalContainer">
<div id="header">
    <nav>
      <a routerLink="/dashboard">Dashboard</a>
      <a routerLink="/articles">Myth Classed</a>
      <a routerLink="/familyTree">Family Tree</a>
      <a routerLink="/galery">Gallery</a>
    </nav>
</div>
<div id="animation">
<div id="container">
    
    <h2>Newest Myth Articles</h2>
    <div class="articles-menu">
        <a *ngFor="let article of articles" routerLink="/detail/{{article.id}}">
            {{article.name}}
        </a>
    </div>
    <app-article-search></app-article-search>

</div>



</div>
</div>

<app-messages></app-messages>
<div id="GreekParallax"> </div>
</div>
